// @flow
import React from 'react';
import { Link } from 'react-router';
import classNames from 'classnames/bind';

import { useCurrencySign } from 'app/common/components-next/currency';
import IconDinner from 'app/common/icons/IconDinner';

import styles from './CardCafeteria.scss';
import MoreLink from '../MoreLink';


type Props = {
  spent: string,
  balance: string,
  link: string,
  className: string,
}

const CardCafeteria = ({ spent, balance, link, className }: Props) => {
  const currency = useCurrencySign('spaceBefore');

  return (
    <div className={classNames(styles.root, className)}>
      <div className={styles.content}>
        <div>
          {spent}
          {spent && currency}
        </div>
        <div className={styles.balance}>
          {balance}
          {balance && currency}
        </div>
      </div>
      <Link to={link} className={styles.icon}><IconDinner /></Link>
      <MoreLink to={link} />
    </div>
  );
};

export default CardCafeteria;
